import {createActionCreator} from '../common/actions';

export type PageDescription = {
    url: string,
    pageTitle?: string,
};

export const NavigateTo = createActionCreator<PageDescription>('NAV_GOTO');
export const NavigateByReplacingCurrent = createActionCreator<PageDescription>('NAV_GOTO_REPLACE');
